import React from "react";
import { NavLink } from "react-router-dom";

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.currentstate = { logo: require("./../../images/logo/logo-dark.png") };
  }

  updateFooterLogo = (updatedlogo) => {
    this.currentstate.logo = updatedlogo;
  };

  render() {
    return (
      <>
        <footer className="site-footer footer-large  footer-dark	footer-wide">
          {/* FOOTER BLOCKES START */}
          <div className="footer-top overlay-wraper">
            <div className="overlay-main" />
            <div className="container">
              <div className="row">
                {/* ABOUT COMPANY */}
                <div className="col-lg-3 col-md-6 col-sm-6">
                  <div className="widget widget_about">
                    {/*<h4 class="widget-title">About Company</h4>*/}
                    <div className="logo-footer clearfix p-b15">
                      <NavLink to={"./"}>
                        <img src={this.currentstate.logo} alt="" />
                      </NavLink>
                    </div>
                    <p className="max-w400">
                      At JIT, we make it easy to get what you need—when you need
                      it. From materials to labour and rentals, we serve with
                      care and efficiency. Your trusted partner for timely
                      services.
                    </p>
                    <ul className="social-icons  mt-social-links">
                      <li>
                        <NavLink
                          target="_blank"
                          to={
                            "https://www.facebook.com/profile.php?id=61585420591906"
                          }
                          className="fa fa-facebook"
                        />
                      </li>
                      <li>
                        <NavLink
                          to={"https://www.instagram.com/jit2_026/"}
                          className="fa fa-instagram"
                        ></NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* RESENT POST */}
                <div className="col-lg-3 col-md-6 col-sm-6">
                  <div className="widget widget_address_outer">
                    <h4 className="widget-title">Contact Us</h4>
                    <ul className="widget_address">
                      <li>
                        No.20, Salai Road, Big Sowrashtra Street, Woraiyur Main
                        Road, Trichy - 620003
                      </li>
                      <li>jit.services13@gmail.com</li>

                      <li>+91 90478 85552</li>
                    </ul>
                  </div>
                </div>
                {/* USEFUL LINKS */}
                <div className="col-lg-3 col-md-6 col-sm-6 footer-col-3">
                  <div className="widget widget_services inline-links">
                    <h4 className="widget-title">Useful links</h4>
                    <ul>
                      <li>
                        <NavLink to={"/about"}>About</NavLink>
                      </li>
                      <li>
                        <NavLink to={"/services?id=ecommerce"}>
                          E-commerce
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to={"/services?id=labour"}>
                          Labour Service
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to={"/services?id=apartmentsg"}>
                          Apartment Handling
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to={"/contact"}>Contact us</NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* TAGS */}
                <div className="col-lg-3 col-md-6 col-sm-6">
                  <div className="widget recent-posts-entry-date">
                    <h4 className="widget-title">Location</h4>

                    <iframe
                      src="https://www.google.com/maps?q=No.20,+Salai+Road,+Big+Sowrashtra+Street,+Woraiyur+Main+Road,+Trichy+-+620003&output=embed"
                      width="100%"
                      height="250"
                      title="Just In Time Company Location Map - Trichy"
                      style={{ border: 0, borderRadius: 15 }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* FOOTER COPYRIGHT */}
          <div className="footer-bottom overlay-wraper">
            <div className="overlay-main" />
            <div className="container">
              <div className="row">
                <div className="mt-footer-bot-center">
                  <span className="copyrights-text">
                    © 2025 All Rights Reserved, JIT
                  </span>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </>
    );
  }
}

export default Footer;
